import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';

const mutationUpdateSimOffers = (onSuccess, onError) => {
    return {
        mutationFn: ({ targetOrganizationUuid, offers }) => {
            return client.put(ORGANIZATION.UPDATE_SIM_OFFERS.url, { targetOrganizationUuid, offers });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateSimOffers;